import { Store, StoreConfig } from '@datorama/akita';
import { createInitialTimeAndAttendanceState, TimeAndAttendanceState } from './time-and-attendance.model';

@StoreConfig({ name: 'timeAndAttendance', resettable: true })
export class TimeAndAttendanceStore extends Store<TimeAndAttendanceState> {
  constructor() {
    super(createInitialTimeAndAttendanceState());
  }
}

export const timeAndAttendanceStore = new TimeAndAttendanceStore();